import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Line } from "react-chartjs-2";

// Register chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
);

const options = {
  animation: {
    duration: 0,
  },
  interaction: {
    mode: 'nearest' as const,
    axis: 'x' as const,
    intersect: false,
  },
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      type: "time" as const,
      time: {
        unit: "day" as const,
      },
      distribution: 'series',
      grid: {
        display: false,
      },
      ticks: {
        display: true,
        color: "#f1f5f9",
        font: {
          size: window.innerWidth < 1500 ? 9 : (window.innerWidth < 1800 ? 10 : 13),
        },
        maxTicksLimit: 6,
      },
    },
    y: {
      grid: {
        display: false,
        color: 'rgba(255, 255, 255, 0.2)',
        tickBorderDash: [2, 2],
        tickLength: 8,
      },
      ticks: {
        display: true,
        color: "#f1f5f9",
        crossAlign: "far" as const,
        font: {
          size: window.innerWidth < 1500 ? 9 : (window.innerWidth < 1800 ? 10 : 13),
        },
        callback: function (value: any) {
          return value.toFixed(0);
        },
      },
    },
  },
  elements: {
    line: {
      tension: 0,
      borderWidth: 2,
      pointRadius: 0,
    },
  },
  plugins: {
    datalabels: {
      display: false,
    },
    hover: {
      mode: 'index' as const,
      animationDuration: 0,
    },
    annotation: {
    },
    tooltip: {
      enabled: true,
      mode: "nearest" as const,
      position: "nearest" as const,
      bodyFont: {
        size: 11,
      },
      titleFont: {
        size: 11,
      },
      borderColor: '#65F4CD',
      borderWidth: 1,
      backgroundColor: "white",
      titleColor: "#000000",
      bodyColor: "#333333",
      axis: "x" as const,
      intersect: false,
      filter: function (tooltipItem: any) {
        return tooltipItem.datasetIndex < 2;
      },
    },
    legend: {
      display: false,
    },
    zoom: {
      zoom: {
        drag: {
          enabled: true,
          backgroundColor: "rgba(62, 252, 173, 0.2)",
          borderColor: "rgb(19, 146, 93)",
          borderWidth: 1,
        },
        wheel: {
          enabled: true,
          modifierKey: "ctrl" as const,
        },
        mode: "x" as const,
        limits: {
          x: {
            minRange: 1000 * 60 * 60 * 24 * 1,
          },
        },
        onZoom: ({ chart }: any) => {
          const xAxis = chart.scales.x;
          const range = xAxis.max - xAxis.min;
          const maxRangeMonth = 1000 * 60 * 60 * 24 * 30;
          const maxRangeYear = 1000 * 60 * 60 * 24 * 365;
          const maxRange = maxRangeMonth;
          if (range > maxRange) {
            // Reset to max allowed zoom out
            const center = (xAxis.max + xAxis.min) / 2;
            xAxis.options.min = center - maxRange / 2;
            xAxis.options.max = center + maxRange / 2;
            chart.update();
          }
        },
      },
    },
  },
};

const FourLineChart = ({ data }: any) => {
  return <Line
    data={data}
    options={options}
    className="h-full"
  />;
};

export default FourLineChart;
